import { JobBean }  from './job.bean';

export class ItemCheckJobBean extends JobBean{
    constructor (){
        super()
        this.param={itens:[]}
    }
    public associateJob(writData){       
        if (!this.userParam){
            this.userParam={
              itensViewed:[],
              itensActed:[]
            }
        }
        if (writData.triggerKind=='onSuccess'){
            if (!this.userParam.itensActed){
                this.userParam.itensActed=[]
            }
            this.userParam.itensActed.push({
                item:writData.entity.id,
                action:'onSuccess'
            })
        }
        else if (writData.triggerKind=='onFail'){
            if (!this.userParam.itensActed){
                this.userParam.itensActed=[]
            }
            this.userParam.itensActed.push({
                item:writData.entity.id,
                action:'onFail'
            })           
        }
        else{
            if (!this.userParam.itensViewed){
                this.userParam.itensViewed=[]
            }

            this.userParam.itensViewed.push(writData.item.objectId)
        }
        if (writData.test){
            this.testJob(writData);
        }
    }
    public testJob(writData){
        let testView=false;
        let testAction=false;

        this.myActionPoint=0;
        this.myViewPoint=0
        if (this.viewPt){//Test View
            this.param.itensViewed.forEach(itToTest=>{
                this.userParam.itensViewed.forEach(itTested=>{
                    if (itToTest==itTested){
                        this.myViewPoint+=this.viewPt;
                    }
                })
            })
            if (this.myViewPoint>=this.testViewPoint){
                testView=true;
            }
        }
        else {
            testView=true;
        }
        if (this.actionPt){//Test Right/Wrong
            this.param.itensActed.forEach(itToTest=>{
                this.userParam.itensActed.forEach(itTested=>{
                    if (itToTest.item==itTested.item && itToTest.action==itTested.action){
                        this.myActionPoint+=this.actionPt;
                    }
                })
            })
            if (this.myActionPoint>=this.testActionPoint){
                testAction=true;
            }
        }
        else {
            testAction=true
        }

        this.myPoint=this.myActionPoint+this.myViewPoint;
        if (testView && testAction){
            this.completed=true;
            let date=new Date();
            this.completedDate=date.getTime();
        }
    }
}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/beansts/quests/ItemCheckJob.ts